import { Divider, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function SidebarBrand() {
  const { t } = useTranslation();
  const logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column">
      <Text
        fontSize="xl"
        fontWeight="800"
        color={logoColor}
        my="32px"
        data-testid="sidebar-title"
      >
        {t('admin.nav.title')}
      </Text>
      <Divider mb="20px" />
    </Flex>
  );
}
